export const BACKGDROP_REQUEST = 'BACKGDROP_REQUEST'

export const backdropRequest=(payload)=>({
    type: BACKGDROP_REQUEST,
    payload
})